// A Wise suggestion that can't be confirmed as it is gets its fix where it is (Mitch, 2026-11-04: "it's yet another step
// where I'm expected to peck around and maybe find how to clear the error, rather than just being offered a remedial
// way to clear the conflict and/or enter missing info"): the disabled Confirm becomes what clears it. A choice only a
// person can make ("use Choose…"): Choose… itself. Anything on a PO (no lines yet, prices missing): the PO, opened beside
// the table, where its lines are filled in, a paper PO's too ("Why can't it just open up the PO so I can edit it?";
// shared/po.ts paperLines); Confirm lights up once it can pay it.
import type { Suggestion } from "../../../../shared/bills.ts";
import type { useBillIndex } from "../../lib/bills.ts";
import { Button } from "../../ui/controls.tsx";
import { PaneLink } from "../../ui/SidePane.tsx";

type Ix = ReturnType<typeof useBillIndex>;
export type WiseFix = { kind: "fill_po"; poId: string } | { kind: "open_po"; poId: string } | { kind: "choose" };

/** What clears a blocked suggestion, worked out from what's there now (stored suggestions carry only the words). */
export function wiseFix(s: Suggestion, ix: Ix): WiseFix | null {
  if (!s.blocked) return null;
  const target = s.targets.find((x) => x.kind === "po" || x.kind === "po_unpriced");
  if (target && !(ix.poLinesByPo.get(target.id) ?? []).length) return { kind: "fill_po", poId: target.id };
  if (s.blocked.includes("Choose…") || !target) return { kind: "choose" };
  return { kind: "open_po", poId: target.id };
}

/** The fix's button, where Confirm would be. */
export function FixButton({ fix, ix, onChoose }: { fix: WiseFix; ix: Ix; onChoose: () => void }) {
  if (fix.kind === "choose")
    return (
      <Button size="sm" variant="primary" onClick={onChoose} title="Pick what it paid by hand">
        Choose…
      </Button>
    );
  const po = ix.poById.get(fix.poId);
  if (!po) return null;
  return (
    <PaneLink
      kind="po"
      id={po.id}
      to={`/pos?open=${po.id}`}
      title={fix.kind === "fill_po" ? `Add what ${po.number} bought on the PO; a line left without a price is priced by this payment` : undefined}
      className="inline-flex h-7 items-center rounded-md bg-accent px-2.5 text-[12px] font-medium text-white hover:bg-accent-hover"
    >
      {fix.kind === "fill_po" ? `Fill in ${po.number}` : `Open ${po.number}`}
    </PaneLink>
  );
}
